import { createContext } from 'react';

const QrsContext = createContext(null);

export default QrsContext;
